import React, { ReactElement } from "react";
import styled from "@emotion/styled";
import { Box, Container, Theme, useMediaQuery, useTheme } from "@mui/material";
import { SettingsSidebar } from "@features/settings/components/SettingsSidebar/SettingsSidebar";
import { SettingsMobileHeader } from "@features/settings/components/SettingsSidebar/SettingsMobileHeader";
import { Header, LayoutWithSidebar } from "@components";
import { Breadcrumbs } from "@rentablo/components";

const StyledContainer = styled(Container)`
  display: flex;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing(0, 6, 14)} !important;

  ${({ theme }) => theme.breakpoints.down("md")} {
    padding: ${({ theme }) => theme.spacing(0, 4, 12)} !important;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    margin-top: 54px;
  }
`;

type Props = {
  breadcrumbs: BreadcrumbItem[];
  children: React.ReactNode;
  title: string;
  subtitle?: string;
  actionButton?: ReactElement;
};

export const SettingsLayout = ({
  title,
  subtitle,
  breadcrumbs,
  children,
  actionButton,
}: Props) => {
  const theme = useTheme();
  const isLessMd = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md")
  );

  return (
    <LayoutWithSidebar
      sidebar={<SettingsSidebar />}
      mobileHeader={<SettingsMobileHeader />}
      breadcrumbs={breadcrumbs}
    >
      <StyledContainer>
        <Box maxWidth="736px" width="100%">
          {isLessMd && (
            <Breadcrumbs
              items={breadcrumbs}
              showBackButton={false}
              sx={{
                margin: `${theme.spacing(6, 0, 5, 0)} !important`,
              }}
            />
          )}
          <Header
            title={title}
            subtitle={subtitle}
            mb={11}
            actionButton={actionButton}
          />
          {children}
        </Box>
      </StyledContainer>
    </LayoutWithSidebar>
  );
};
